<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <h1 class="title is-1">Wing Deals</h1>
        <div class="container">
          <!-- <iframe src="https://calendar.google.com/calendar/embed?src=atlhotwingsdotcom%40gmail.com&ctz=America%2FNew_York" frameborder="0" scrolling="no"></iframe> -->
          <iframe src="https://calendar.google.com/calendar/embed?showTitle=0&amp;showPrint=0&amp;showCalendars=0&amp;mode=AGENDA&amp;height=600&amp;wkst=1&amp;bgcolor=%23ffffff&amp;src=atlhotwingsdotcom%40gmail.com&amp;color=%23853104&amp;ctz=America%2FNew_York" style="border-width:0" width="800" height="600" frameborder="0" scrolling="no"></iframe>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContactForm from "./ContactForm";
export default {
  name: "Home",
  data() {
    return {};
  },
  components: {
    ContactForm
  }
};
</script>

<style scoped>
.hero {
  text-align: center;
}
.align-left {
  text-align: left;
}
.container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 35px;
  height: 0;
  overflow: hidden;
}
.container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Deals.vue